import React from 'react';
import Btn, { btnTypes } from '../../../btn';
import { isFn } from '../../utils';
import { selectors, stateKeys } from '../../model';
import { useStoreSelector } from '../../hooks/useStoreSelector';
import { useHandlers } from '../../contexts';
import styles from './Actions.module.scss';

const { selectValue } = selectors;

const DefaultActions = ({ onCancel, onOk }) => {
  return (
    <div className={styles.root}>
      <Btn
        type={btnTypes.primaryInvert}
        onClick={onCancel}
        className={styles.btn}
      >
        Отмена
      </Btn>
      <Btn
        type={btnTypes.primary}
        onClick={onOk}
        className={styles.btn}
      >
        Применить
      </Btn>
    </div>
  );
};

const renderActionsSelector = (state) =>
  selectValue(state, stateKeys.renderActions);
const multipleSelector = (state) => selectValue(state, stateKeys.multiple);

const Actions = () => {
  const renderActions = useStoreSelector(renderActionsSelector);
  const multiple = useStoreSelector(multipleSelector);
  const { onCancel, onOk } = useHandlers();

  return isFn(renderActions) ? (
    renderActions(multiple ? { onCancel, onOk } : { onCancel })
  ) : (
    <DefaultActions
      onCancel={onCancel}
      onOk={onOk}
    />
  );
};

export default Actions;
